import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as fromAuth from '../../../auth/reducers';

@Component({
  selector: 'portal-dashboard-folders-wrapper',
  template: `
    <ng-container *ngIf="useV3Messaging$ | async; else legacyMessaging">
      <!-- V3 Messaging Component -->
      <portal-dashboard-folders-v3></portal-dashboard-folders-v3>
    </ng-container>

    <ng-template #legacyMessaging>
      <!-- Legacy Messaging Component -->
      <portal-dashboard-folders></portal-dashboard-folders>
    </ng-template>
  `,
  styles: [
    `
      :host {
        flex-grow: 1;
        margin-right: 16px;
      }
    `
  ]
})
export class DashboardFoldersWrapperComponent implements OnInit {
  useV3Messaging$: Observable<boolean>;

  constructor(private _store: Store<fromAuth.State>) {}

  ngOnInit() {
    // Check clinic options to determine which messaging implementation to use
    this.useV3Messaging$ = this._store.pipe(
      select(fromAuth.getMessagingV3Enabled),
      map((enabled) => (enabled !== undefined ? enabled : false))
    );
  }
}
